// Lightweight reversible obfuscation for route values that end up in the
// URL query string (e.g. engagementId). This is NOT encryption and provides
// no real security on its own — the cipher key ships in the JS bundle, so
// anyone inspecting the app can decode it. It only keeps the raw id from
// being plainly readable at a glance in the address bar. Real access control
// must still be enforced by the backend when it resolves the id.
const OBFUSCATION_KEY = "bdo-insyts-route-state";

const xorCipher = (input, key) => {
  let output = "";
  for (let i = 0; i < input.length; i++) {
    output += String.fromCharCode(
      input.charCodeAt(i) ^ key.charCodeAt(i % key.length)
    );
  }
  return output;
};

export const encodeRouteId = (value) => {
  if (value === undefined || value === null || value === "") return value;
  try {
    const xored = xorCipher(String(value), OBFUSCATION_KEY);
    return btoa(unescape(encodeURIComponent(xored)));
  } catch (e) {
    return String(value);
  }
};

export const decodeRouteId = (value) => {
  if (value === undefined || value === null || value === "") return value;
  try {
    const xored = decodeURIComponent(escape(atob(value)));
    return xorCipher(xored, OBFUSCATION_KEY);
  } catch (e) {
    return undefined;
  }
};